import styled from 'styled-components';
import { Text } from '@blueprism/ui-core';

export const StyledDescription = styled(Text)`
  word-break: break-word;
  font-size: inherit;
`;
